import { DataModel } from "common/models/utility-models/base-model"

export class RegisterStep3Model extends DataModel {
    score10:any=''
    score12:any=''
    physicsMarks:any=''
    chemistryMarks:any=''
    mathematicsMarks:any=''
    jeeScore:any =''
}
